import React from 'react';
import './Header.css';
import { FaRegUser } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import sanitizeHtml from 'sanitize-html';

function Header(props) {
  const navigate = useNavigate();
  async function logout() {
    localStorage.clear();
    let url = `${process.env.REACT_APP_GATEWAY_URL}${process.env.REACT_APP_USER_GATEWAY_PATH}/auth/logoff`;
    window.location.replace(url);
  }

  function summaryOnclick() {
    const url = props.heading === 'Outstanding Assignments Summary' ? '/' : '/OutstandingAssignment';
    navigate(sanitizeHtml(url));
  }

  function profileOnclick() {
    navigate('/Profile');
  }
  return (
    <div className="fmc-top-banner__demo-page">
      <div className="fmc-top-banner__demo d-flex">
        <img className="fmc-top-banner__demo-billboard" src={process.env.PUBLIC_URL + '/Assets/Ford.png'} alt="" />
        <h4 className="fmc-type--heading5">{props.heading}</h4>

        {(() => {
          if (
            props.heading === 'Repo Admin Tool' ||
            props.heading === 'Contractor Profile' ||
            props.heading === 'Add Contractor Profile' ||
            props.heading === 'Update Coverage Area' ||
            props.heading === 'Coverage' ||
            props.heading === 'Modify Contractor Profile' ||
            props.heading === 'View Coverage'
          ) {
            return (
              <div>
                <button className="fmc-button" style={{ display: `${props.value}` }} onClick={logout}>
                  Logout<span className="fds-icon fds-icon fds-icon--offset-right fds-font--ford-icons__clear"></span>
                </button>
              </div>
            );
          } else if (props.heading === 'Unauthorized User') {
            return (
              <button className="fmc-button" onClick={summaryOnclick}>
                Reauthenticate <span className="fds-icon fds-icon fds-icon--offset-right"></span>
              </button>
            );
          } else {
            return (
              <div>
                <button className="fmc-button" onClick={summaryOnclick}>
                  Summary <span className="fds-icon fds-icon fds-icon--offset-right "></span>
                </button>

                <button className="fmc-button" onClick={profileOnclick}>
                  <div className="icon_text">
                    <FaRegUser /> Profile
                  </div>
                  <span className="fds-icon fds-icon fds-icon--offset-right "></span>
                </button>

                <button className="fmc-button" style={{ display: `${props.value}` }} onClick={logout}>
                  Logout<span className="fds-icon fds-icon fds-icon--offset-right fds-font--ford-icons__clear"></span>
                </button>
              </div>
            );
          }
        })()}
        {/*<div>*/}
        {/*    <button className="fmc-button">Summary*/}
        {/*        <span*/}
        {/*            className="fds-icon fds-icon fds-icon--offset-right "></span>*/}
        {/*    </button>*/}

        {/*    <button className="fmc-button">*/}
        {/*        <div className="icon_text"><FaRegUser/> ProfileJs</div>*/}
        {/*        <span*/}
        {/*            className="fds-icon fds-icon fds-icon--offset-right "></span>*/}
        {/*    </button>*/}
        {/*    <button className="fmc-button">Help<span*/}
        {/*        className="fds-icon fds-icon fds-icon--offset-right fds-font--ford-icons__info-filled"></span>*/}
        {/*    </button>*/}

        {/*    <button className="fmc-button" style={{display: `${props.value}`}}>Logout<span*/}
        {/*        className="fds-icon fds-icon fds-icon--offset-right fds-font--ford-icons__clear"></span>*/}

        {/*    </button>*/}

        {/*</div>*/}
      </div>
    </div>
  );
}

Header.propTypes = {
  heading: PropTypes.string,
  value: PropTypes.string,
};

export default Header;
